<template>
    <div class="theme-index-wrap">
        <template v-if="proShowModel=='speed'">
            <section class="other-product clearfix">
                <template v-for="item in sectionList">
                    <template v-if="itemP.webFlag == 'lechun_sku_speed'&&itemP.productId!=proId" v-for="itemP in item.items">
                        <sku :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay"></sku>
                    </template>
                </template>
            </section>
        </template>
        <template v-if="proShowModel=='gather'">
            <section class="other-product clearfix">
                <ul class="clearfix">
                    <template v-for="item in sectionList">
                        <template v-for="itemP in item.items">
                            <sku v-if="itemP.webFlag == 'sku'||itemP.webFlag == 'lechun_sku'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay"></sku>
                            <promotion v-if="itemP.webFlag == 'promotion'||itemP.webFlag == 'promotion_variety'||itemP.webFlag == 'promotion_fls'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay"></promotion>
                            <skuPromotion v-if="itemP.webFlag == 'sku_promotion'||itemP.webFlag == 'lechun_promotion_sku'||itemP.webFlag == 'lechun_promotion_sku_nv'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay"></skuPromotion>
                            <active v-if="itemP.webFlag == 'secondKill'||itemP.webFlag == 'coffKill'||itemP.webFlag == 'groupKill'||itemP.webFlag == 'chipsKill'||itemP.webFlag == 'activeKill'||itemP.webFlag == 'milkKill'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay" :flag="itemP.webFlag"></active>
                        </template>
                    </template>
                </ul>

            </section>
        </template>
        <template v-if="proShowModel=='cardGather'">
            <section class="other-product clearfix">
                <ul class="clearfix">
                    <template v-for="itemP in sectionList">
                        <active v-if="itemP.webFlag == 'secondKill'||itemP.webFlag == 'coffKill'||itemP.webFlag == 'groupKill'||itemP.webFlag == 'chipsKill'||itemP.webFlag == 'activeKill'||itemP.webFlag == 'milkKill'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay" :flag="itemP.webFlag"></active>
                    </template>
                </ul>

            </section>
        </template>
        <template v-else-if="proShowModel==0">
            <template v-for="(item,index) in sectionList">
                <section :class="item.navName3+'-wrap section-item clearfix section'+index" :data-nav="item.navSn">
                    <header class="wrap-header" :class="'wrap-header-'+vipDay">
                        <h3>{{item.navName1}}</h3>
                        <p>{{item.navName2}}</p>
                    </header>
                    <div :class="item.navName3+'-content'">
                        <ul class="clearfix">
                            <template v-for="itemP in item.items">
                                <sku v-if="itemP.webFlag == 'sku'||itemP.webFlag == 'lechun_sku'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay"></sku>
                                <promotion v-if="itemP.webFlag == 'promotion'||itemP.webFlag == 'promotion_variety'||itemP.webFlag == 'promotion_fls'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay"></promotion>
                                <skuPromotion v-if="itemP.webFlag == 'sku_promotion'||itemP.webFlag == 'lechun_promotion_sku'||itemP.webFlag == 'lechun_promotion_sku_nv'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay"></skuPromotion>
                                <active v-if="itemP.webFlag == 'secondKill'||itemP.webFlag == 'coffKill'||itemP.webFlag == 'groupKill'||itemP.webFlag == 'chipsKill'||itemP.webFlag == 'activeKill'||itemP.webFlag == 'milkKill'" :itemP="itemP" :vipLevel="vipLevel" :vipDay="vipDay" :flag="itemP.webFlag"></active>
                            </template>
                        </ul>
                    </div>
                </section>
            </template>
        </template>
    </div>
</template>

<script>
    import {invokeApi} from '@/resource/js/GLOBAL2'
    import {GetQueryString} from '@/resource/js/common'

    import sku from '@/components/module_pro/sku.vue'
    import promotion from '@/components/module_pro/promotion.vue'
    import skuPromotion from '@/components/module_pro/sku_promotion.vue'
    import active from '@/components/module_pro/active.vue'

    export default{
        data(){
            return {
            }
        },
        props:['sectionList','proShowModel','proType','vipLevel','vipDay','proId'],
        components:{
            sku,promotion,skuPromotion,active
        },
        mounted(){
        },
        methods:{
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../resource/css/color";
    @import "../../resource/css/default";
    /*@import "../../resource/css/christmas-theme";*/
    /*@import "../../assets/css/swiper-4.1.6.min.css";*/

    /**activity、variety**/
    .theme-index-wrap{
        background: $indexBg;
        background-size: 100% auto;
        padding-top: $indexPadding;
    }
    .product-detail-wrap .theme-index-wrap{
        padding-top: 0;
    }
    .section-item{
        position: relative;
        .wrap-header {
            position: relative;
            padding: .60rem 0;
            text-align: center;
        }

        .wrap-header h3 {
            font-size: .34rem;
            font-weight: normal;
            margin-bottom: .20rem;
            color:#333333;
        }

        .wrap-header p {
            font-size: .22rem;
            color: #999999;
        }
        .wrap-header-isvipday h3,.wrap-header-isvipday p{
            /*color: #ffffff;*/
        }

        .wrap-header-brand {
            display: none;
            width: 7.5rem;
            margin: .33rem auto 0;
        }

        .sku-header-brand {
            display: block;
        }
        ul{
            display: flex;
            flex-wrap: wrap;
        }

    }
    .other-product{
        ul{
            display: flex;
            flex-wrap: wrap;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/index/section_pro.vue